import { Sparkles, ShieldCheck, KeyRound, MessageCircle, Smartphone, Mail, FileText, BadgeCheck, Gift, Star, Lock, CreditCard, Building2, UserCheck, Bell, Info } from "lucide-react";

export const ACTION_ICONS = {
  sparkles: Sparkles, shield: ShieldCheck, key: KeyRound, whatsapp: MessageCircle, phone: Smartphone, mail: Mail,
  document: FileText, badge: BadgeCheck, gift: Gift, star: Star, lock: Lock, card: CreditCard,
  company: Building2, user: UserCheck, bell: Bell, info: Info,
};

export const ActionIcon = ({ icon, iconUrl, className = "mx-auto h-10 w-10" }) => {
  if (iconUrl) return <img src={iconUrl} alt="" className={`${className} object-contain`} data-testid="custom-action-icon-img" />;
  const Icon = ACTION_ICONS[icon] || Sparkles;
  return <Icon className={className} style={{ color: "var(--brand)" }} data-testid="custom-action-icon" />;
};
